module.exports = __webpack_public_path__ + "static/media/Discuss.4f6e8511.png";